'use strict';

var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');

var ColumnsDialogView = Marionette.ItemView.extend({
    template: require('components/common/templates/columns'),

    events: {
        'click a#js-save': 'saveClicked',
    },

    initialize: function (options) {
        this.options = options || {};
    },

    serializeData: function () {
        var data = { selected: Misc.selectWhere(this.options.selected, undefined, 'id') };
        Misc.addFieldListData(
            Misc.selectWhere(this.options.fields, function (item) {
                return !AppState.isColumnFixed(item);
            }),
            data
        );
        return data;
    },

    saveClicked: function (e) {
        var self = this;
        e.preventDefault();
        App.hideModal();
        var selection = _.map($('#col_multi_select').val() || [], function (item) {
            var data = Misc.cloneAsJSON(
                _.where(AppState.uniqueFields(self.options.category), { id: Misc.columnNameToField(item) })[0]
            );
            data.id = item;
            data.name = data.name || Misc.getFieldName(data, self.options.category);
            return data;
        });
        this.options.save_cb(selection);
    },

    onAttach: function () {
        this.initializeMultiSelect();
    },

    onRender: function () {
        this.initializeMultiSelect();
    },

    initializeMultiSelect: function () {
        Misc.initializeMultiSelect('#col_multi_select', i18n.TR('Verfügbar'), i18n.TR('Tabelle'), true);
    },
});

module.exports = ColumnsDialogView;
